export default "__VITE_ASSET__eb0bafc3__"